// Only scroll to top if there’s NO hash in the URL
if (!window.location.hash && gsap) {
  gsap.to(window, { duration: 0, scrollTo: 0 });
}
window.addEventListener("load", function () {
  const preloader = document.getElementById("preloader");
  document.body.classList.remove("is-preloading");
  document.body.classList.add("page-ready");

  if (preloader) setTimeout(() => preloader.remove(), 1000); // remove after fade-out
  initAnimations();

  function initAnimations() {
    gsap.registerPlugin(
      ScrollTrigger,
      ScrollToPlugin,
      SplitText,
      TextPlugin,
      ScrambleTextPlugin
    );

    /* ========================
     Fade + Motion Animations
    ========================== */
    const fadeElems = document.querySelectorAll(".animate");

    fadeElems.forEach((elem, index) => {
      const delay = parseFloat(elem.dataset.delay) || 0;
      const duration = parseFloat(elem.dataset.duration) || 1.2;

      // Custom movement from data attributes
      const dataX = parseFloat(elem.dataset.x) || 0;
      const dataY = parseFloat(elem.dataset.y) || 0;

      // Optional trigger and start position
      const triggerSelector = elem.dataset.trigger;
      const startPosition = elem.dataset.start || "top bottom-=100";

      // Resolve trigger element
      const triggerElement = triggerSelector
        ? elem.closest(triggerSelector)
        : elem;

      // Default movement (fallback)
      let fromX = dataX;
      let fromY = dataY;
      let scaleFrom = 1;
      let scaleTo = 1;

      let debug = -1;

      if (!dataX && !dataY) {
        if (elem.classList.contains("fade-top")) fromY = -60;
        else if (elem.classList.contains("fade-bottom")) fromY = 60;
        else if (elem.classList.contains("fade-left")) fromX = -60;
        else if (elem.classList.contains("fade-right")) fromX = 60;
        else if (elem.classList.contains("fade-zoom-in"))
          (scaleFrom = 1), (scaleTo = 1.1);
        else if (elem.classList.contains("fade-zoom-out"))
          (scaleFrom = 1.1), (scaleTo = 1);
      }

      // Animation setup
      const fromVars = {
        opacity: 0,
        x: fromX,
        y: fromY,
        scale: scaleFrom,
      };

      gsap.fromTo(elem, fromVars, {
        opacity: 1,
        x: 0,
        y: 0,
        scale: scaleTo,
        duration: duration,
        delay: delay,
        ease: "power4.out",
        overwrite: "auto",
        scrollTrigger: {
          trigger: triggerElement,
          start: startPosition,
          toggleActions: "play none none none",
          once: true,
          markers: debug === index, // turn true for debugging
        },
      });
    });

    /* ========================
     Smooth Scroll for #hash
  ========================== */
    // Prevent browser restoring old scroll on reload
    window.history.scrollRestoration = "manual";

    function smoothScrollTo(target) {
      if (!target) return;
      gsap.to(window, {
        duration: 0.6,
        scrollTo: { y: target, offsetY: 120 },
        ease: "linear",
        // ease: "power3.inOut",
      });
    }

    if (window.location.hash) {
      const target = document.querySelector(window.location.hash);
      if (target) smoothScrollTo(target);
    }

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (!target) return;

      e.preventDefault();
      smoothScrollTo(target);
    });

    /* ========================
      highlight Text Animation
  ========================== */
    const highlightWrappers = document.querySelectorAll(".highlight-wrapper");

    highlightWrappers.forEach((wrapper) => {
      const topText = wrapper.querySelector('[data-highlight="duplicate"]');
      const bottomText = wrapper.querySelector('[data-highlight="main"]');
      if (!topText || !bottomText) return;

      // Split words
      const splitTop = new SplitText(topText, { type: "words" });
      const splitBottom = new SplitText(bottomText, { type: "words" });

      // Set both layers visible
      gsap.set([topText, bottomText], { opacity: 1 });

      // Create a timeline controlled by scroll
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: "top bottom-=100",
          end: "top 35%",
          scrub: true,
          markers: false, // turn true for debugging
        },
        defaults: { ease: "none" },
      });

      // Build instant opacity change steps
      splitTop.words.forEach((word, i) => {
        // Each word instantly hides as we scroll
        tl.to(word, { opacity: 0, duration: 0.001 }, i * 0.05);
      });
    });

    /* ========================
     Text Plugin Animation
    (Dynamic text typing or morph)
  ========================== */
    const textElems = document.querySelectorAll(".text-typing");

    textElems.forEach((elem) => {
      const finalText =
        elem.getAttribute("data-text") || elem.textContent.trim();
      const delay = parseFloat(elem.dataset.delay) || 0;

      gsap.fromTo(
        elem,
        { text: "" },
        {
          text: finalText,
          duration: 2,
          delay: delay,
          ease: "none",
          scrollTrigger: {
            trigger: elem,
            start: "top bottom-=100",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    /* ========================
     Scramble Text Animation
     (Scrambled reveal effect)
    ========================== */
    const scrambleElems = document.querySelectorAll(".scramble-animate");

    scrambleElems.forEach((elem) => {
      const finalText =
        elem.getAttribute("data-text") || elem.textContent.trim();
      const delay = parseFloat(elem.dataset.delay) || 0;

      gsap.fromTo(
        elem,
        { text: "" },
        {
          duration: 2,
          delay: delay,
          scrambleText: {
            text: finalText,
            chars:
              "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
            revealDelay: 0.5,
            speed: 0.4,
          },
          ease: "power2.out",
          scrollTrigger: {
            trigger: elem,
            start: "top bottom-=100",
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  }
});

// document.addEventListener("lazyloaded", () => {
//   ScrollTrigger.refresh();
// });

document.addEventListener("DOMContentLoaded", function () {
  const tabLinks = document.querySelectorAll(".videoTab a");
  const tabItems = document.querySelectorAll(".videoTab li");
  const tabPanes = document.querySelectorAll(".tab-pane");

  tabLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const targetId = this.getAttribute("href");

      // Remove active state from all tabs
      tabItems.forEach((item) => item.classList.remove("active"));
      tabPanes.forEach((pane) => {
        pane.classList.remove("active", "in");
      });

      // Activate clicked tab
      this.parentElement.classList.add("active");

      // Activate corresponding pane
      const targetPane = document.querySelector(targetId);
      if (targetPane) {
        targetPane.classList.add("active", "in");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded",function(){
  // DELEGATED CLICK for dropdown toggle
    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('.horizontal-facet-filter-bar .dropdown-toggle');
      if (!toggle) return;

      e.preventDefault();
      const dropdown = toggle.closest('.dropdown');
      const menu = dropdown.querySelector('.dropdown-menu');

      // Close all other dropdowns
      document.querySelectorAll('.horizontal-facet-filter-bar .dropdown-menu.open').forEach(function (openMenu) {
        if (openMenu !== menu) {
          openMenu.classList.remove('open');
          openMenu.previousElementSibling.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current dropdown
      menu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', menu.classList.contains('open'));
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (e.target.closest('.horizontal-facet-filter-bar .dropdown')) return;

      document.querySelectorAll('.horizontal-facet-filter-bar .dropdown-menu.open').forEach(function (menu) {
        menu.classList.remove('open');
        menu.previousElementSibling.setAttribute('aria-expanded', 'false');
      });
    });
})

document.addEventListener("DOMContentLoaded", function () {
  let modal = null;
  let overlay = null;

  function openModal(templateId) {
    const template = document.getElementById(templateId);
    if (!template) return;

    overlay = document.createElement("div");
    overlay.className = "consultation-overlay";

    modal = document.createElement("div");
    modal.className = "consultation-modal";

    modal.innerHTML = `
      <div class="consultation-modal__content">
        <button class="consultation-close" aria-label="Close">
          <svg aria-hidden="true" focusable="false" fill="none" width="16" class="" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path>
          </svg>
        </button>
        ${template.innerHTML}
      </div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(modal);
    document.body.style.overflow = "hidden";

    overlay.addEventListener("click", (e) => {
      e.preventDefault();
      closeModal();
    });
    const closeLink = modal.querySelectorAll(
      ".consultation-close,.consultation-close-link"
    );
    closeLink.forEach((el) =>
      el.addEventListener("click", (e) => {
        e.preventDefault();
        closeModal();
      })
    );
  }

  function closeModal() {
    if (modal) modal.remove();
    if (overlay) overlay.remove();
    document.body.style.overflow = "";
    modal = overlay = null;
  }

  // 🔥 EVENT DELEGATION (KEY PART)
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest("a.consultation-link[data-template]");
    if (!trigger) return;

    e.preventDefault();
    openModal(trigger.dataset.template);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });
});


(function () {
  // Debounce utility
  function debounce(fn, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  function checkAllTimelines() {
    const timelines = document.querySelectorAll('.timeline');

    timelines.forEach(timeline => {
      const items = timeline.querySelectorAll('.timeline-item');
      let totalItemsWidth = 0;

      items.forEach(item => {
        totalItemsWidth += item.offsetWidth;
      });

      if (timeline.offsetWidth < totalItemsWidth) {
        timeline.classList.add('scroll-timeline');
      } else {
        timeline.classList.remove('scroll-timeline');
      }
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', checkAllTimelines);

  // Run on resize with debounce
  window.addEventListener(
    'resize',
    debounce(checkAllTimelines, 200)
  );
})();


(function () {
  // Debounce utility
  function debounce(fn, delay) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  function checkAllTimelines() {
    const buttonswrapper = document.querySelectorAll('.buttons-wrapper');

    buttonswrapper.forEach(btnWrapper => {
      const items = btnWrapper.querySelectorAll('.btn');
      let totalItemsWidth = 0;

      items.forEach(item => {
        totalItemsWidth += item.offsetWidth;
      });

      // ✅ Get flex gap value
      const styles = getComputedStyle(btnWrapper);
      const gap =
        parseFloat(styles.columnGap || styles.gap || 0);

      // ✅ Add total gap width (gaps = items - 1)
      const totalGapWidth = gap * (items.length - 1);

      const totalContentWidth = totalItemsWidth + totalGapWidth;

      if (btnWrapper.clientWidth < totalContentWidth) {
        btnWrapper.classList.add('scroll-btn');
      } else {
        btnWrapper.classList.remove('scroll-btn');
      }
    });
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', checkAllTimelines);

  // Run on resize with debounce
  window.addEventListener(
    'resize',
    debounce(checkAllTimelines, 200)
  );
})();
